module.exports = __webpack_public_path__ + "img/babo-3.4c292425.png";